export default "__VITE_ASSET__CK$29D$f__"